@if (comparisonAvailable) {
  <app-comparison-html-template
    [recDataSource]="recDataSource"
    [lcaDataSource]="lcaDataSource"
    [analysesDataLoaded]="analysesDataLoaded"
    [recTableData]="recTableData"
    [lcaTableData]="lcaTableData"
    [newLcaAllowed]="newLcaAllowed"
    [volumeAvailable]="volumeAvailable"
    [weightAvailable]="weightAvailable"
    (createRecAnalysis)="createNewRecyclabilityAnalysis($event)"
    (createLcaAnalysis)="createNewLifecycleAnalysis($event)">
  </app-comparison-html-template>
} @else {
  <div class="comparison-unavailable">
    <alert type="warning" class="lca-chart-alert alert">
      <mat-icon>info</mat-icon>
      {{ 'analysis.analysisComparison.noDistributionCountryWarning' | transloco }}
    </alert>
    <button mat-raised-button color="primary" type="button" (click)="goBack()">
      {{ 'common.buttons.returnToPreviousPage' | transloco }}
    </button>
  </div>
}
